import { render, staticRenderFns } from "./SelectParty.vue?vue&type=template&id=64d270d8"
import script from "./SelectParty.vue?vue&type=script&lang=ts"
export * from "./SelectParty.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports